module.exports = __webpack_public_path__ + "img/filled-star-20x20.2a41a3b5.svg";